// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  position: relative;
  background: black;
  text-transform: capitalize;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.05);
  width: 100%;
  height: 55px;
  margin-bottom: 20px;
}

.wrapper {
  color: var(--ion-color-primary);
  display: flex;
  flex-direction: column;
}

.separator {
  width: 100%;
  height: 1px;
  margin: 16px 0;
  background: white;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
}

ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
}

ion-col {
  font-size: 13px;
  font-family: AppFontSemiBold;
  color: #000;
}

.selected {
  opacity: 1 !important;
}

ion-icon {
  zoom: 1.1;
}

.logout {
  margin: 20px 0px 0px 10px;
}
.logout ion-button {
  padding: 10px 0px;
  font-family: AppFont, sans-serif;
  text-transform: capitalize;
  --background: white;
  color: var(--ion-color-primary);
  font-weight: 700;
}
.logout ion-button ion-icon {
  zoom: 1;
  color: var(--ion-color-primary);
}

.header-wrap {
  margin: 10px;
}

.lang-block {
  margin-top: 10rem;
  padding: 20px;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
}

.link {
  display: flex;
  align-items: center;
}

.top-corner {
  position: fixed;
  top: 0px;
  left: 0;
  width: 17.3%;
  aspect-ratio: 114/153;
}
@media (min-width: 991px) {
  .top-corner {
    display: none;
  }
}

.logo {
  width: 39px;
  height: 38px;
  padding: 0;
  padding-left: 16px;
}

.item {
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,iBAAA;EACA,0BAAA;AADD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAAD;;AAEA;EACC,+BAAA;EACA,aAAA;EACA,sBAAA;AACD;;AAEA;EACC,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AACD;;AAEA;EACC,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AACD;;AAEA;EACC,YAAA;EACA,kBAAA;AACD;;AAEA;EACC,mBAAA;EACA,YAAA;EACA,eAAA;AACD;;AAEA;EACC,YAAA;EACA,sCAAA;EACA,0BAAA;AACD;;AACA;EACC,eAAA;EACA,4BAAA;EACA,WAAA;AAED;;AACA;EACC,qBAAA;AAED;;AACA;EACC,SAAA;AAED;;AAAA;EACC,yBAAA;AAGD;AAFC;EACC,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;AAIF;AAHE;EACC,OAAA;EACA,+BAAA;AAKH;;AAAA;EACC,YAAA;AAGD;;AAAA;EACC,iBAAA;EACA,aAAA;AAGD;;AAAA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;AAGD;;AAAA;EACC,aAAA;EACA,mBAAA;AAGD;;AAAA;EACC,eAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,qBAAA;AAGD;AC5GE;EDoGF;IAQE,aAAA;EAIA;AACF;;AADA;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAID;;AADA;EACC,kBAAA;AAID","sourcesContent":["@use '../../../theme/mixins' as *;\n\napp-menu-modal {\n\tposition: relative;\n\tbackground: black;\n\ttext-transform: capitalize;\n}\n.header-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground-color: rgba(0, 0, 0, 0.05);\n\twidth: 100%;\n\theight: 55px;\n\tmargin-bottom: 20px;\n}\n.wrapper {\n\tcolor: var(--ion-color-primary);\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.separator {\n\twidth: 100%;\n\theight: 1px;\n\tmargin: 16px 0;\n\tbackground: white;\n}\n\nion-icon {\n\twidth: 32px;\n\tmargin-right: 3px;\n\tpadding: 4px;\n\tborder-radius: 0;\n}\n\n.version {\n\topacity: 0.3;\n\tfont-size: x-small;\n}\n\nion-row {\n\talign-items: center;\n\tpadding: 2px;\n\tcursor: pointer;\n}\n\nion-button {\n\tcolor: white;\n\t--background: rgba(255, 255, 255, 0.3);\n\tbackdrop-filter: blur(4px);\n}\nion-col {\n\tfont-size: 13px;\n\tfont-family: AppFontSemiBold;\n\tcolor: #000;\n}\n\n.selected {\n\topacity: 1 !important;\n}\n\nion-icon {\n\tzoom: 1.1;\n}\n.logout {\n\tmargin: 20px 0px 0px 10px;\n\tion-button {\n\t\tpadding: 10px 0px;\n\t\tfont-family: AppFont, sans-serif;\n\t\ttext-transform: capitalize;\n\t\t--background: white;\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-weight: 700;\n\t\tion-icon {\n\t\t\tzoom: 1;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n.header-wrap {\n\tmargin: 10px;\n}\n\n.lang-block {\n\tmargin-top: 10rem;\n\tpadding: 20px;\n}\n\n.version {\n\tposition: absolute;\n\tbottom: 3px;\n\tright: 10px;\n}\n\n.link {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.top-corner {\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0;\n\twidth: 17.3%;\n\taspect-ratio: 114 / 153;\n\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.logo {\n\twidth: 39px;\n\theight: 38px;\n\tpadding: 0;\n\tpadding-left: 16px;\n}\n\n.item {\n\tpadding-left: 10px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
